export default "__VITE_ASSET__B_v12qMj__"